import * as React from 'react';

// Import global CSS
import './src/components/Layout.css';

// Gatsby browser API types
interface WrapRootElementArgs {
  element: React.ReactElement;
}

// This is required for react-helmet to work properly with Gatsby
export const wrapRootElement = ({ element }: WrapRootElementArgs) => {
  return element;
};